export default __webpack_public_path__ + "static/media/1.8f4e8594.jpg";